(() => {
  const parseJSON = (/** @type {string} */ jsonString) => {
    try {
      return JSON.parse(jsonString);
    } catch (error) {
      console.error('Invalid JSON:', /** @type {Error} */ (error).message);
      return null;
    }
  };

  const getGlobalValues = () => {
    const jsonNode = document.querySelector('#DataLayerGlobalValuesJSON');

    if (!jsonNode?.textContent) {
      console.error('Global values script tag is missing or empty');
      return null;
    }

    return parseJSON(jsonNode.textContent.trim());
  };

  const buildCorrectedRemovedCartEvent = (eventObj, pendingRemoval) => {
    const cartItem = pendingRemoval.cartItem;
    const variantId = String(cartItem.variant_id);

    const listContext = getCartItemListContext(variantId);
    const productId = cartItem.product_id;

    const [item_category, item_category2, item_category3, item_category4, item_category5] =
      getProductCategories(productId);

    const item = {
      item_id: variantId,

      item_name: cartItem.product_title,

      quantity: cartItem.quantity,

      price: typeof cartItem.final_price === 'number' ? cartItem.final_price / 100 : undefined,

      affiliation: listContext?.affiliation ?? cartItem.product_type ?? undefined,

      coupon: cartItem.discounts?.[0]?.title || undefined,

      discount: cartItem.total_discount ? cartItem.total_discount / 100 : undefined,

      index: listContext?.index ?? undefined,

      item_brand: listContext?.item_brand ?? 'Bundaberg',

      item_category: listContext?.item_category ?? item_category,

      item_category2: listContext?.item_category2 ?? item_category2,

      item_category3: listContext?.item_category3 ?? item_category3,

      item_category4: listContext?.item_category4 ?? item_category4,

      item_category5: listContext?.item_category5 ?? item_category5,

      item_list_id: listContext?.item_list_id != null ? String(listContext.item_list_id) : undefined,

      item_list_name: listContext?.item_list_name,

      item_variant:
        cartItem.variant_title && cartItem.variant_title !== 'Default Title' ? cartItem.variant_title : undefined,

      location_id: undefined,
    };

    console.log('CORRECTED REMOVE ITEM:', item);

    window.__bundabergPendingCartRemoval = null;

    return {
      event: 'remove_from_cart',
      remove_from_cart_type: 'Cart',
      timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
      _clear: true,
      ecommerce: {
        currency: eventObj?.data?.cartLine?.cost?.totalAmount?.currencyCode || 'AUD',
        value: Number((Number(item.price || 0) * Number(item.quantity || 0)).toFixed(2)),
        items: [item],
      },
    };
  };

  document.addEventListener('click', function (event) {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;

    const link = target?.closest('.featured-blog-posts-card a');

    if (!link) {
      return;
    }

    const card = link.closest('.featured-blog-posts-card');

    if (!card) {
      return;
    }

    const titleElement = card.querySelector('h2, h3, h4, .title');

    const recipeName = titleElement?.textContent.trim();

    if (!recipeName) {
      return;
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'content_interaction',
      journey_type: 'Content',
      interaction_type: 'Recipe',
      interaction_name: recipeName,
      timestamp: Date.now(),
    });
  });

  document.addEventListener('click', function (event) {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;

    const link = target?.closest('.social-icons__wrapper a');

    if (!link) {
      return;
    }

    const linkUrl = link.href;
    const linkName = link.getAttribute('aria-label') || link.textContent.trim();

    window.dataLayer = window.dataLayer || [];

    // Check whether this click has already been pushed
    const alreadyTracked = window.dataLayer.some(
      (item) =>
        item?.event === 'outbound_click' &&
        item?.link_url === linkUrl &&
        item?.link_name === linkName &&
        Date.now() - (item?.timestamp ?? 0) < 500
    );

    if (alreadyTracked) {
      return;
    }

    window.dataLayer.push({
      event: 'outbound_click',
      link_name: linkName,
      link_url: linkUrl,
      outbound_link_type: 'Footer',
      timestamp: Date.now(),
    });
  });

  /**
   * Converts a URL slug to Title Case.
   *
   * @param {string | undefined} slug
   * @returns {string | undefined}
   */
  const slugToTitleCase = (slug) => {
    if (!slug) return undefined;

    return slug
      .split('-')
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  /**
   * Returns item_category-5 for a product's collections.
   * item_category, 2, 3, 4 = discrete collection titles (in Shopify's returned order).
   * item_category5 = all remaining collections, pipe-joined.
   * Tries the DOM (PLP card) first, then falls back to globalValues (PDP).
   * @param {string | number | undefined} productId
   */
  const getProductCategories = (productId) => {
    let collections = [];

    if (productId) {
      const card = document.querySelector(`[data-product-id="${productId}"]`);
      if (card?.dataset.productCollections) {
        collections = card.dataset.productCollections.split('|').filter(Boolean);
      }
    }

    if (collections.length === 0) {
      const raw = globalValues.productCollections;
      if (Array.isArray(raw)) {
        collections = raw;
      } else if (typeof raw === 'string') {
        collections = raw.split('|').filter(Boolean);
      }
    }

    if (collections.length === 0 && productId) {
      const cartMap = globalValues.cartProductCollections || {};
      const cartCollections = cartMap[String(productId)];
      if (Array.isArray(cartCollections)) {
        collections = cartCollections;
      }
    }

    const item_category = collections[0] || undefined;
    const item_category2 = collections[1] || undefined;
    const item_category3 = collections[2] || undefined;
    const item_category4 = collections[3] || undefined;
    const item_category5 = collections.slice(4).join('|') || undefined;

    return [item_category, item_category2, item_category3, item_category4, item_category5];
  };

  /**
   * Returns the GA4 affiliation for a product.
   * Gift Cards and Gift Vouchers are reported as Merchandise
   * to align with the Ecommerce Journey Variable Mapping.
   *
   * @param {any} product
   * @returns {string | undefined}
   */
  const getAffiliation = (product) => {
    if (!product) {
      return undefined;
    }

    const title = (product.title || '').toLowerCase();

    if (title.includes('gift')) {
      return 'Merchandise';
    }

    return product.type || undefined;
  };

  /** @type {Object.<string, any> | null} */
  const globalValues = getGlobalValues();

  if (!globalValues) return;

  const PAGE_TYPE_MAP = parseJSON(globalValues.pageTypeMap) || {};
  const SITE_SECTION_MAP = parseJSON(globalValues.siteSectionMap) || {};
  const ADD_TO_CART_TYPE_MAP = parseJSON(globalValues.addToCartTypeMap) || {};

  /**
   * Maps a Shopify cart line to a dataLayer item object.
   * @param {any} cartLine
   * @param {{ index?: any, item_list_id?: any, item_list_name?: any }} [listContext]
   */
  const mapCartLineToItem = (cartLine, listContext) => {
    const productId = cartLine?.merchandise?.product?.id;
    const [item_category, item_category2, item_category3, item_category4, item_category5] =
      getProductCategories(productId);

    return {
      item_id: cartLine?.merchandise?.id != null ? String(cartLine.merchandise.id) : undefined,
      item_name: cartLine?.merchandise?.product?.title || undefined,
      quantity: cartLine?.quantity || undefined,
      price: cartLine?.merchandise?.price?.amount || undefined,

      affiliation: listContext?.affiliation ?? getAffiliation(cartLine?.merchandise?.product),

      coupon: undefined,
      discount: undefined,

      index: listContext?.index ?? undefined,

      item_brand: listContext?.item_brand ?? 'Bundaberg',

      item_category: listContext?.item_category ?? item_category,

      item_category2: listContext?.item_category2 ?? item_category2,

      item_category3: listContext?.item_category3 ?? item_category3,

      item_category4: listContext?.item_category4 ?? item_category4,

      item_category5: listContext?.item_category5 ?? item_category5,

      item_list_id: listContext?.item_list_id != null ? String(listContext.item_list_id) : undefined,

      item_list_name: listContext?.item_list_name,

      item_variant:
        cartLine?.merchandise?.title == null || cartLine?.merchandise?.title === 'Default Title'
          ? undefined
          : cartLine?.merchandise?.title,

      location_id: undefined,
    };
  };

  /**
   * Maps a Shopify product variant to a dataLayer item object (for list views).
   * @param {any} variant
   * @param {number} index
   * @param {{ item_list_id?: any, item_list_name?: any }} [listContext]
   */
  const mapVariantToItem = (variant, index, listContext) => {
    const productId = variant?.product?.id;
    const [item_category, item_category2, item_category3, item_category4, item_category5] =
      getProductCategories(productId);

    return {
      id: variant?.product?.id || undefined,

      item_id: variant?.id != null ? String(variant.id) : undefined,
      item_name: `${variant?.product?.title} - ${variant?.title}`.replace(' - Default Title', '') || undefined,
      quantity: 1,
      price: variant?.price?.amount || undefined,
      affiliation: getAffiliation(variant?.product),
      coupon: undefined,
      discount: undefined,
      index: index,
      item_brand: 'Bundaberg',
      item_category,
      item_category2,
      item_category3,
      item_category4,
      item_category5,

      item_list_id: listContext?.item_list_id != null ? String(listContext.item_list_id) : undefined,
      item_list_name: listContext?.item_list_name || undefined,
      item_variant: variant?.title === 'Default Title' ? undefined : variant?.title,
      location_id: undefined,
    };
  };

  /**
   * Strips the `id` property from each item in an array.
   * @param {any[] | undefined} items
   */
  const stripIdFromItems = (items) =>
    items?.map((/** @type {any} */ item) => {
      const { id, ...rest } = item;
      return rest;
    }) || undefined;

  const CART_LIST_CONTEXT_KEY = 'cartItemListContext';

  /**
   * Saves list context for a variant when it's added to cart.
   * Also persists to a cookie so the checkout pixel sandbox can access it.
   * @param {string} variantId
   * @param {{ index?: any, item_list_id?: any, item_list_name?: any }} context
   */
  const saveCartItemListContext = (variantId, context) => {
    try {
      const stored = sessionStorage.getItem(CART_LIST_CONTEXT_KEY);
      const map = stored ? JSON.parse(stored) : {};
      map[variantId] = context;
      const json = JSON.stringify(map);
      sessionStorage.setItem(CART_LIST_CONTEXT_KEY, json);
      document.cookie = `${CART_LIST_CONTEXT_KEY}=${encodeURIComponent(json)};path=/;SameSite=Lax`;
    } catch {
      // silent fail
    }
  };

  /**
   * Retrieves stored list context for a variant in cart.
   * @param {string} variantId
   * @returns {{ index?: any, item_list_id?: any, item_list_name?: any } | undefined}
   */
  const getCartItemListContext = (variantId) => {
    try {
      const stored = sessionStorage.getItem(CART_LIST_CONTEXT_KEY);
      if (!stored) return undefined;
      const map = JSON.parse(stored);
      return map[variantId] || undefined;
    } catch {
      return undefined;
    }
  };

  // Stores the latest cart items so we can identify the actual
  // product the user clicked when removing an item.
  let cartItemSnapshot = {};

  const saveCartItemSnapshot = (items) => {
    cartItemSnapshot = {};

    if (!Array.isArray(items)) return;

    items.forEach((item) => {
      if (item?.item_id) {
        cartItemSnapshot[String(item.item_id)] = item;
      }
    });
  };

  // Capture the actual cart item clicked by the user before BOGOS
  // processes the cart change.
  document.addEventListener(
    'click',
    (event) => {
      const removeButton = event.target.closest('.cart-items__remove');

      if (!removeButton) return;

      const row = removeButton.closest('tr[data-key]');

      if (!row) return;

      const variantId = row.querySelector('[data-variant-id]')?.dataset.variantId;

      if (!variantId) return;

      window.__bundabergPendingCartRemoval = {
        variantId: String(variantId),
        timestamp: Date.now(),
        cartItem: null,
      };

      console.log('CAPTURED USER CART REMOVAL:', {
        variantId,
        cartKey: row.dataset.key,
      });

      // Capture the cart BEFORE BOGOS modifies it.
      fetch('/cart.js')
        .then((response) => response.json())
        .then((cart) => {
          const cartItem = cart.items?.find((item) => String(item.variant_id) === String(variantId));

          if (window.__bundabergPendingCartRemoval?.variantId === String(variantId)) {
            window.__bundabergPendingCartRemoval.cartItem = cartItem;

            console.log('CAPTURED CART ITEM:', cartItem);
          }
        })
        .catch((error) => {
          console.warn('Unable to capture cart item:', error);
        });
    },
    true
  );

  /**
   * Extracts the subset of item fields needed to reconstruct list context
   * later (e.g. for product_viewed / add_to_cart), keyed by item_id.
   * @param {any} item
   * @returns {{
   *   index: any,
   *   item_list_id: any,
   *   item_list_name: any,
   *   item_brand: any,
   *   affiliation: any,
   *   item_category: any,
   *   item_category2: any,
   *   item_category3: any,
   *   item_category4: any,
   *   item_category5: any
   * }}
   */
  const buildListContextEntry = (item) => ({
    index: item.index,
    item_list_id: item.item_list_id,
    item_list_name: item.item_list_name,

    item_brand: item.item_brand,
    affiliation: item.affiliation,

    item_category: item.item_category,
    item_category2: item.item_category2,
    item_category3: item.item_category3,
    item_category4: item.item_category4,
    item_category5: item.item_category5,
  });

  const LAST_VIEWED_ITEMS_KEY = 'lastViewedCollectionItems';

  /**
   * Persists the full (pre-stripIdFromItems) item list for a view_item_list-type
   * event, keyed by product id, so the #ResultsList product-card click handler
   * in m-data-layer-inject.js can look up full item details (id, item_id,
   * item_name, price, etc.) for the select_item event. This is separate from
   * lastViewedCollectionData, which is keyed by variant id (item_id) and only
   * holds list context for product_viewed / add_to_cart.
   * @param {string | undefined} currency
   * @param {any[] | undefined} items
   */
  const saveLastViewedCollectionItems = (currency, items) => {
    if (!Array.isArray(items) || items.length === 0) return;

    try {
      localStorage.setItem(LAST_VIEWED_ITEMS_KEY, JSON.stringify({ currency, items }));
    } catch {
      // silent fail
    }
  };

  /**
   * @typedef {Object} FormatterParams
   * @property {any} eventObj
   */

  window.dataLayerFormatters({
    /**
     * @param {FormatterParams} params
     */
    page_viewed: ({ eventObj }) => {
      const countryCode = globalValues.localization?.country?.isoCode;

      const path = globalValues.request?.path || '';
      const pathSegments = path.split('/').filter(Boolean);

      /** @type {Object.<string, string>} */
      const SITE_SECTION_PATH_MAP = {
        '': 'Home',
        collections: 'Products',
        products: 'Products',
        'pages/recipes': 'Recipes',
        'blogs/recipes': 'Recipes',
        'pages/visit-us': 'Distillery',
        'pages/book-a-tour': 'Distillery',
        'pages/faq': 'FAQ',
        'pages/contact-us': 'Contact Us',
        'pages/our-story': 'Our Story',
        'pages/single-barrel': 'Products',
        'pages/campfire-rum': 'Products',
        'pages/limited-edition': 'Products',
        'pages/history': 'Our Story',
        'pages/the-craft-of-rum': 'Our Story',
        'pages/forever-classic': 'Our Story',
        'pages/our-partnership': 'Our Story',
        'pages/nrl-partnership': 'Our Story',
        'pages/queensland-rum-day': 'Our Story',

        blogs: 'Articles',
        account: 'Account',
        cart: 'Checkout',
        404: '404',
      };

      /** @type {Object.<string, string>} */
      const SITE_SUBSECTION_EXCEPTIONS = {
        'limited-edition': 'Limited Editions',
      };

      const getSiteSection = () => {
        if (path === '/') return 'Home';
        // Check 2-segment paths first (e.g. pages/faq)
        const twoSegment = pathSegments.slice(0, 2).join('/');
        if (SITE_SECTION_PATH_MAP[twoSegment]) return SITE_SECTION_PATH_MAP[twoSegment];
        // Check 1-segment paths (e.g. collections, products)
        if (SITE_SECTION_PATH_MAP[pathSegments[0]]) return SITE_SECTION_PATH_MAP[pathSegments[0]];
        // Fallback to existing map
        return (
          Object.keys(SITE_SECTION_MAP).find((siteSection) =>
            SITE_SECTION_MAP[siteSection]
              .split(',')
              .includes(globalValues.template?.suffix || globalValues.template?.name)
          ) || undefined
        );
      };

      const getSiteSubsection = () => {
        if (path === '/') return undefined;

        // Collection / PLP pages
        if (pathSegments[0] === 'collections' && pathSegments[2] !== 'products') {
          const collectionSlug = pathSegments[1];

          if (!collectionSlug) return undefined;

          return SITE_SUBSECTION_EXCEPTIONS[collectionSlug] || slugToTitleCase(collectionSlug);
        }

        // Product / PDP pages
        const productsIndex = pathSegments.indexOf('/products/');

        if (productsIndex !== -1) {
          const productSlug = pathSegments[productsIndex + 1];

          if (!productSlug) return undefined;

          return slugToTitleCase(productSlug);
        }

        // For other pages, use page title
        return globalValues.pageTitle || undefined;
      };

      return {
        event: 'page_view',
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
        user_id: globalValues.user?.id || undefined,
        user_locale: globalValues.user?.id && countryCode ? countryCode : undefined,
        page_locale: countryCode || undefined,
        region: 'APAC',
        site_type: 'Ecommerce',
        page_type:
          Object.keys(PAGE_TYPE_MAP).find((pageType) =>
            PAGE_TYPE_MAP[pageType].split(',').includes(globalValues.template?.name)
          ) || undefined,
        site_section: getSiteSection() || getSiteSubsection(),
        site_subsection: getSiteSubsection(),
        brand: globalValues.brandName || 'Bundaberg',
      };
    },

    /**
     * @param {FormatterParams} params
     */
    product_viewed: ({ eventObj }) => {
      // Look up list context from the last viewed collection/search
      const lastListData = (() => {
        try {
          const stored = localStorage.getItem('lastViewedCollectionData');
          if (!stored) return null;

          const parsed = JSON.parse(stored);
          const variantId = String(eventObj?.data?.productVariant?.id);

          if (!variantId) return null;

          return parsed[variantId] || null;
        } catch {
          return null;
        }
      })();

      const itemName =
        eventObj?.data?.productVariant?.title === 'Default Title'
          ? eventObj?.data?.productVariant?.product?.title
          : `${eventObj?.data?.productVariant?.product?.title} - ${eventObj?.data?.productVariant?.title}`;

      const discount =
        globalValues.variant?.compareAtPrice > globalValues.variant?.price
          ? Number((globalValues.variant.compareAtPrice - globalValues.variant.price).toFixed(2))
          : undefined;

      const productId = eventObj?.data?.productVariant?.product?.id;
      const [item_category, item_category2, item_category3, item_category4, item_category5] =
        getProductCategories(productId);

      return {
        event: 'view_item',
        view_item_type: 'Ecommerce',
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
        _clear: true,
        ecommerce: {
          currency: eventObj?.data?.productVariant?.price?.currencyCode || undefined,
          value: Number(eventObj?.data?.productVariant?.price?.amount) || undefined,
          items: [
            {
              item_id: eventObj?.data?.productVariant?.id != null ? String(eventObj.data.productVariant.id) : undefined,
              item_name: itemName,
              quantity: 1,
              price: Number(eventObj?.data?.productVariant?.price?.amount) || undefined,
              affiliation: getAffiliation(eventObj?.data?.productVariant?.product),
              coupon: undefined,
              discount: discount,
              index: lastListData?.index ?? undefined,
              item_brand: 'Bundaberg',
              item_category,
              item_category2,
              item_category3,
              item_category4,
              item_category5,

              item_list_id: lastListData?.item_list_id != null ? String(lastListData.item_list_id) : undefined,
              item_list_name: lastListData?.item_list_name ?? undefined,
              item_variant:
                eventObj?.data?.productVariant?.title === 'Default Title'
                  ? undefined
                  : eventObj?.data?.productVariant?.title,
              location_id:
                typeof globalValues.variant?.locationId === 'string' && globalValues.variant.locationId.trim() !== ''
                  ? globalValues.variant.locationId
                  : undefined,
            },
          ],
        },
      };
    },
    /**
     * @param {FormatterParams} params
     */
    product_added_to_cart: ({ eventObj }) => {
      // Look up list context from the last viewed collection/search
      const lastListData = (() => {
        try {
          const stored = localStorage.getItem('lastViewedCollectionData');
          if (!stored) return null;

          const parsed = JSON.parse(stored);
          const variantId = String(eventObj?.data?.cartLine?.merchandise?.id);

          if (!variantId) return null;

          return parsed[variantId] || null;
        } catch {
          return null;
        }
      })();

      const productId = eventObj?.data?.cartLine?.merchandise?.product?.id;

      const [item_category, item_category2, item_category3, item_category4, item_category5] =
        getProductCategories(productId);

      // Persist list context per variant for remove_from_cart
      const variantId = eventObj?.data?.cartLine?.merchandise?.id;

      const context = lastListData ?? {
        affiliation: getAffiliation(eventObj?.data?.cartLine?.merchandise?.product),
        item_brand: 'Bundaberg',

        item_category,
        item_category2,
        item_category3,
        item_category4,
        item_category5,

        index: undefined,
        item_list_id: undefined,
        item_list_name: undefined,
      };

      if (variantId) {
        saveCartItemListContext(variantId, context);
      }

      return {
        event: 'add_to_cart',
        add_to_cart_type:
          Object.keys(ADD_TO_CART_TYPE_MAP).find((pageType) =>
            ADD_TO_CART_TYPE_MAP[pageType].split(',').includes(globalValues.template?.name)
          ) || undefined,
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
        _clear: true,
        ecommerce: {
          currency: eventObj?.data?.cartLine?.cost?.totalAmount?.currencyCode || undefined,
          value: eventObj?.data?.cartLine?.cost?.totalAmount?.amount || undefined,
          items: [mapCartLineToItem(eventObj?.data?.cartLine, context)],
        },
      };
    },
    /**
     * @param {FormatterParams} params
     */
    product_removed_from_cart: ({ eventObj }) => {
      const bogosVariantId = eventObj?.data?.cartLine?.merchandise?.id;
      const pendingRemoval = window.__bundabergPendingCartRemoval;

      const pendingIsRecent = pendingRemoval && Date.now() - pendingRemoval.timestamp < 10000;

      const clickedVariantId = pendingIsRecent ? pendingRemoval.variantId : undefined;

      console.log('REMOVE FORMATTER:', {
        bogosVariantId,
        clickedVariantId,
        capturedCartItem: pendingRemoval?.cartItem,
      });

      const hasMatchingPendingRemoval =
        pendingIsRecent &&
        pendingRemoval.cartItem &&
        String(pendingRemoval.cartItem.variant_id) === String(clickedVariantId);

      if (hasMatchingPendingRemoval) {
        return buildCorrectedRemovedCartEvent(eventObj, pendingRemoval);
      }

      const variantId = bogosVariantId;
      const listContext = variantId ? getCartItemListContext(variantId) : undefined;

      return {
        event: 'remove_from_cart',
        remove_from_cart_type: 'Cart',
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
        _clear: true,
        ecommerce: {
          currency: eventObj?.data?.cartLine?.cost?.totalAmount?.currencyCode || undefined,
          value: eventObj?.data?.cartLine?.cost?.totalAmount?.amount || undefined,
          items: [mapCartLineToItem(eventObj?.data?.cartLine, listContext)],
        },
      };
    },

    /**
     * @param {FormatterParams} params
     */
    cart_viewedX: ({ eventObj }) => {
      return {
        event: 'view_cart',
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
        _clear: true,
        ecommerce: {
          currency: eventObj?.data?.cart?.cost?.totalAmount?.currencyCode || undefined,
          value: eventObj?.data?.cart?.cost?.totalAmount?.amount || undefined,
          items:
            eventObj?.data?.cart?.lines?.map(
              /** @param {any} line, @param {number} index */
              (line, index) => {
                const listContext = getCartItemListContext(line?.merchandise?.id) || {};

                return mapCartLineToItem(line, {
                  index,
                  ...listContext,
                });
              }
            ) || undefined,
        },
      };
    },

    cart_viewed: ({ eventObj }) => {
      const items =
        eventObj?.data?.cart?.lines?.map(
          /** @param {any} line, @param {number} index */
          (line, index) => {
            const listContext = getCartItemListContext(line?.merchandise?.id) || {};

            return mapCartLineToItem(line, {
              index,
              ...listContext,
            });
          }
        ) || undefined;

      saveCartItemSnapshot(items);

      return {
        event: 'view_cart',
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
        _clear: true,
        ecommerce: {
          currency: eventObj?.data?.cart?.cost?.totalAmount?.currencyCode || undefined,
          value: eventObj?.data?.cart?.cost?.totalAmount?.amount || undefined,
          items,
        },
      };
    },
    /**
     * @param {FormatterParams} params
     */
    search_submitted: ({ eventObj }) => {
      setTimeout(() => {
        window.dataLayerPush({
          event: 'search',
          data: {
            timestamp: new Date().toISOString(),
            data: {
              // query: eventObj?.data?.searchResult?.query,
              searchType: 'Manual',
            },
          },
        });
      });

      const searchQuery = eventObj?.data?.searchResult?.query;

      // item_list_id scopes both the dataLayer's view_item_list dedup guard
      // (see sendEvent in m-data-layer-inject.js, which no-ops when
      // item_list_id is undefined) and GA4 list reporting. It's keyed by
      // query so re-firing the same search dedupes, but a genuinely
      // different search term still produces its own view_item_list.
      const searchListContext = {
        item_list_id: searchQuery ? `search_results:${searchQuery}` : 'search_results',
        item_list_name: 'Search Results',
      };

      const searchResultsViewedEvent = {
        event: 'view_item_list',
        item_list_type: 'Search Results',
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
        _clear: true,
        ecommerce: {
          currency: eventObj?.data?.searchResult?.productVariants?.[0]?.price?.currencyCode || undefined,
          value:
            Number(
              [...(eventObj?.data?.searchResult?.productVariants || [])]
                .reduce((sum, v) => sum + (Number(v?.price?.amount) || 0), 0)
                .toFixed(2)
            ) || undefined,
          items:
            eventObj?.data?.searchResult?.productVariants?.map(
              /** @param {any} variant,  @param {number} index */
              (variant, index) => mapVariantToItem(variant, index, searchListContext)
            ) || undefined,
        },
      };

      const map = JSON.parse(localStorage.getItem('lastViewedCollectionData') || '{}');

      (searchResultsViewedEvent.ecommerce.items || []).forEach((item) => {
        map[String(item.item_id)] = buildListContextEntry(item);
      });

      localStorage.setItem('lastViewedCollectionData', JSON.stringify(map));

      saveLastViewedCollectionItems(
        searchResultsViewedEvent.ecommerce.currency,
        searchResultsViewedEvent.ecommerce.items
      );

      return {
        ...searchResultsViewedEvent,
        ecommerce: {
          ...searchResultsViewedEvent.ecommerce,
          items: stripIdFromItems(searchResultsViewedEvent.ecommerce.items),
        },
      };
    },
    /**
     * @param {FormatterParams} params
     */
    collection_viewed: ({ eventObj }) => {
      const listContext = {
        item_list_id: globalValues.collection?.id != null ? String(globalValues.collection.id) : undefined,
        item_list_name: globalValues.collection?.title || undefined,
      };

      const collectionViewedEvent = {
        event: 'view_item_list',
        item_list_type: 'Product',
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
        _clear: true,
        ecommerce: {
          currency: eventObj?.data?.collection?.productVariants?.[0]?.price?.currencyCode || undefined,
          value:
            Number(
              [...(eventObj?.data?.collection?.productVariants || [])]
                .reduce((sum, v) => sum + (Number(v?.price?.amount) || 0), 0)
                .toFixed(2)
            ) || undefined,
          items:
            eventObj?.data?.collection?.productVariants?.map(
              /** @param {any} variant,  @param {number} index */
              (variant, index) => mapVariantToItem(variant, index, listContext)
            ) || undefined,
        },
      };

      const map = JSON.parse(localStorage.getItem('lastViewedCollectionData') || '{}');

      (collectionViewedEvent.ecommerce.items || []).forEach((item) => {
        map[String(item.item_id)] = buildListContextEntry(item);
      });

      localStorage.setItem('lastViewedCollectionData', JSON.stringify(map));

      saveLastViewedCollectionItems(collectionViewedEvent.ecommerce.currency, collectionViewedEvent.ecommerce.items);

      return {
        ...collectionViewedEvent,
        ecommerce: {
          ...collectionViewedEvent.ecommerce,
          items: stripIdFromItems(collectionViewedEvent.ecommerce.items),
        },
      };
    },
    /**
     * @param {FormatterParams} params
     */
    search: ({ eventObj }) => {
      return {
        event: 'search',
        // search_term: eventObj?.data?.query || undefined,
        search_term: undefined,
        search_type: eventObj?.data?.searchType || undefined,
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
      };
    },
    /**
     * @param {FormatterParams} params
     */
    cart_drawer_viewed: ({ eventObj }) => {
      const toDecimal = (amount) => (typeof amount === 'number' ? amount / 100 : amount);

      const items =
        eventObj?.data?.cart?.items?.map(
          /** @param {any} line, @param {number} index */
          (line, index) => {
            const listContext = getCartItemListContext(String(line?.variant_id)) || {};

            const [item_category, item_category2, item_category3, item_category4, item_category5] =
              getProductCategories(line?.product_id);

            return {
              item_id: line?.variant_id != null ? String(line.variant_id) : undefined,
              item_name: `${line?.product_title} - ${line?.variant_title}`.replace(' - null', '') || undefined,
              quantity: line?.quantity || undefined,
              price: toDecimal(line?.final_price),

              affiliation: listContext?.affiliation ?? line?.product_type ?? undefined,

              coupon: line.discounts?.[0]?.title || undefined,
              discount: line.total_discount || undefined,

              index: listContext?.index ?? index,

              item_brand: listContext?.item_brand ?? 'Bundaberg',

              item_category: listContext?.item_category ?? item_category,

              item_category2: listContext?.item_category2 ?? item_category2,

              item_category3: listContext?.item_category3 ?? item_category3,

              item_category4: listContext?.item_category4 ?? item_category4,

              item_category5: listContext?.item_category5 ?? item_category5,

              item_list_id: listContext?.item_list_id != null ? String(listContext.item_list_id) : undefined,

              item_list_name: listContext?.item_list_name,

              item_variant:
                line?.variant_title == null || line?.variant_title === 'Default Title'
                  ? undefined
                  : line?.variant_title,

              location_id: undefined,
            };
          }
        ) || undefined;

      saveCartItemSnapshot(items);

      return {
        event: 'view_cart',
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
        _clear: true,
        ecommerce: {
          currency: eventObj?.data?.cart?.currency || undefined,
          value: toDecimal(eventObj?.data?.cart?.total_price),
          items,
        },
      };
    },
    /**
     * @param {FormatterParams} params
     */
    view_item_list: ({ eventObj }) => {
      const viewItemListEvent = {
        event: 'view_item_list',
        item_list_type: 'Product',
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
        _clear: true,
        ecommerce: {
          currency: eventObj?.data?.payload?.currency || undefined,
          value: eventObj?.data?.payload?.value || undefined,
          items: eventObj?.data?.payload?.items || undefined,
        },
      };

      // Don't overwrite valid list context with an empty list
      if (Array.isArray(viewItemListEvent.ecommerce.items) && viewItemListEvent.ecommerce.items.length > 0) {
        const map = JSON.parse(localStorage.getItem('lastViewedCollectionData') || '{}');

        viewItemListEvent.ecommerce.items.forEach((item) => {
          map[String(item.item_id)] = buildListContextEntry(item);
        });

        localStorage.setItem('lastViewedCollectionData', JSON.stringify(map));

        saveLastViewedCollectionItems(viewItemListEvent.ecommerce.currency, viewItemListEvent.ecommerce.items);
      }

      return {
        ...viewItemListEvent,
        ecommerce: {
          ...viewItemListEvent.ecommerce,
          items: stripIdFromItems(viewItemListEvent.ecommerce.items),
        },
      };
    },
    /**
     * @param {FormatterParams} params
     */
    collection_selected_item: ({ eventObj }) => {
      return {
        event: 'select_item',
        select_item_type: 'Ecommerce',
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
        _clear: true,
        ecommerce: {
          currency: eventObj?.data?.payload?.currency || undefined,
          value: eventObj?.data?.payload?.value || undefined,
          items: stripIdFromItems([eventObj?.data?.payload?.item || {}]),
        },
      };
    },
    /**
     * @param {FormatterParams} params
     */
    select_item: ({ eventObj }) => {
      return {
        event: 'select_item',
        select_item_type: 'Ecommerce',
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
        _clear: true,
        ecommerce: {
          currency: eventObj?.data?.payload?.currency || undefined,
          value: eventObj?.data?.payload?.value || undefined,
          items: stripIdFromItems([eventObj?.data?.payload?.item || {}]),
        },
      };
    },
    /**
     * @param {FormatterParams} params
     */
    video_start: ({ eventObj }) => {
      return {
        event: 'video_start',
        video_title: eventObj?.data?.videoTitle || undefined,
        video_url: eventObj?.data?.videoSrc || undefined,
        timestamp: Date.now(),
      };
    },
    /**
     * @param {FormatterParams} params
     */
    video_progress: ({ eventObj }) => {
      return {
        event: 'video_progress',
        video_title: eventObj?.data?.videoTitle || undefined,
        video_url: eventObj?.data?.videoSrc || undefined,
        video_completion: eventObj?.data?.progress ? eventObj?.data?.progress + '%' : undefined,
        timestamp: Date.now(),
      };
    },
    /**
     * @param {FormatterParams} params
     */
    video_complete: ({ eventObj }) => {
      return {
        event: 'video_complete',
        video_title: eventObj?.data?.videoTitle || undefined,
        video_url: eventObj?.data?.videoSrc || undefined,
        video_completion: eventObj?.data?.progress ? eventObj?.data?.progress + '%' : undefined,
        timestamp: Date.now(),
      };
    },
    /**
     * @param {FormatterParams} params
     */
    form_start: ({ eventObj }) => {
      return {
        event: 'form_start',
        form_type: eventObj?.data?.formType || undefined,
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
      };
    },
    /**
     * @param {FormatterParams} params
     */
    form_submit: ({ eventObj }) => {
      console.log('form submit formatter file');
      console.log(eventObj);
      return {
        event: 'form_submit',
        form_type: eventObj?.data?.formType || undefined,
        status: eventObj?.data?.status || undefined,
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
      };
    },
    /**
     * @param {FormatterParams} params
     */
    newsletter_signup: ({ eventObj }) => {
      return {
        event: 'newsletter_signup',
        form_type: eventObj?.data?.formType || undefined,
        status: eventObj?.data?.status || undefined,
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
        newsletter_optin_type: eventObj?.data?.newsletterOptinType || undefined,
      };
    },
    /**
     * @param {FormatterParams} params
     */
    content_interaction: ({ eventObj }) => {
      return {
        event: 'content_interaction',
        journey_type: eventObj?.data?.journeyType || undefined,
        interaction_type: eventObj?.data?.interactionType || globalValues.pageTitle || undefined,
        interaction_name: eventObj?.data?.interactionName || undefined,
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
      };
    },
    /**
     * @param {FormatterParams} params
     */
    outbound_click: ({ eventObj }) => {
      return {
        event: 'outbound_click',
        link_name: eventObj?.data?.linkName || undefined,
        link_url: eventObj?.data?.linkUrl || undefined,
        outbound_link_type: eventObj?.data?.outboundLinkType || undefined,
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
      };
    },
    /**
     * @param {FormatterParams} params
     */
    navigation_click: ({ eventObj }) => {
      return {
        event: 'navigation_click',
        journey_type: eventObj?.data?.journeyType || undefined,
        navigation_type: eventObj?.data?.navigationType || undefined,
        interaction_name: eventObj?.data?.interactionName || undefined,
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
      };
    },
    /**
     * @param {FormatterParams} params
     */
    scroll: ({ eventObj }) => {
      return {
        event: 'scroll',
        scroll_percentage: eventObj?.data?.scrollPercentage || undefined,
        timestamp: new Date(eventObj?.timestamp)?.getTime() || undefined,
      };
    },
  });
})();
